import { render, staticRenderFns } from "./join1.vue?vue&type=template&id=809e732c&scoped=true&"
import script from "./join1.vue?vue&type=script&lang=js&"
export * from "./join1.vue?vue&type=script&lang=js&"
import style0 from "./join1.vue?vue&type=style&index=0&id=809e732c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809e732c",
  null
  
)

export default component.exports